var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 50 50",
    preserveAspectRatio: "xMidYMid",
    className: "lds-rolling",
    style: {
      background: "'rgba(0, 0, 0, 0) none repeat scroll 0% 0%'"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    fill: "none",
    "ng-attr-stroke": "{{ config.color }}",
    "ng-attr-stroke-width": "{{ config.width }}",
    "ng-attr-r": "{{ config.radius }}",
    "ng-attr-stroke-dasharray": "{{ config.dasharray }}",
    stroke: "#fff",
    strokeWidth: 3,
    r: 12,
    strokeDasharray: "56.548667764616276 20.84955592153876",
    transform: "rotate(169.094 25 25)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 25 25;360 25 25",
    keyTimes: "0;1",
    dur: "0.5s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSpinner);
export default __webpack_public_path__ + "static/media/whiteSpinner.32bb5aa8f493edbb5dbccabcd8c56a8e.svg";
export { ForwardRef as ReactComponent };